/* eslint-disable import/prefer-default-export */
export const BaseUrls = {
  API_URL: import.meta.env.VITE_API_URL 
};